import {DashboardScope} from './model/dashboard-scope.model';

/**
 * Dit si deux cibles de restitution désignent le même objet.
 *
 * Une enquête et un parcours client portent des identifiants indépendants : leur nature entre donc
 * dans la comparaison. Le nom, lui, n'en fait pas partie — deux cibles peuvent s'appeler pareil, et
 * une cible renommée reste la même. L'absence de cible se compare comme une valeur : deux absences
 * se valent.
 */
export const isSameDashboardScope = (first: DashboardScope | null, second: DashboardScope | null): boolean =>
    first?.kind === second?.kind && first?.id === second?.id;
